import { Box, CircularProgress } from '@mui/material'

export const FullScreenProgress = (): JSX.Element => {
  return (
    <Box
      sx={{
        position: 'absolute',
        width: '100%',
        height: '100vh',
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
      }}>
      <CircularProgress />
    </Box>
  )
}
